<template>
    <th
    class="table-header-cell"
    :class="{
        'sortable': entry.sortable,
        'sorted': (sortDirection === 'Asc' || sortDirection === 'Desc' || entry.initialSortDirection) && selectedCell,
        'descending': sortDirection === 'Desc' || (!sortDirection && entry.initialSortDirection === 'Desc')
    }"
    @click="sortColumnHandler">
        {{entry.label}}<span v-if="entry.mandatory"> *</span>
        <!-- Sort Element -->
        <span v-if="entry.sortable" class="sort-by"/>
    </th>
</template>

<script setup>
/* Vue */
import { ref, watch } from 'vue'

/* Emmitters */
const emit = defineEmits(['sortBy'])

/* Props received
@entry {Object}
	- value [String, Object]: value to send to headerCells
	- dataAttr [String, Number]: column identifier
	- mandatory {Boolean} to apply '*' in our label
	- sortable {Boolean} prop to add possibility to order by this column, we will use dataAttr to emit which column we want to sort-by
*/
const props = defineProps({
	entry: Array,
    sortByDirection: String,
    selectedCell: Boolean
})
const sortDirection = ref()

const sortColumnHandler = () => {
    if (!props.entry.sortable) return
	sortDirection.value = !sortDirection.value || sortDirection.value === 'Desc' ? 'Asc' : 'Desc'
	emit('sortBy', { direction: sortDirection.value, sortBy: props.entry.dataAttr })
}

watch(() => props.sortByDirection, (newVal, oldVal) => {
    if (props.sortByDirection !== props.entry.dataAttr) sortDirection.value = null
})
</script>

<style lang="scss" scoped>
.table-header-cell {
    height: 48px;
    padding-right: 16px;
    position:relative;

    box-sizing:border-box;

    @include H8-Medium;
    color: var(--secondary-dark-2);
    text-align:start;

    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    cursor: default;

	background-color: var(--secondary-light-4);
    border-top: 1px solid var(--secondary-light-2);

    &:first-letter {
        text-transform: uppercase;
    }

    &:first-of-type {
        padding-left: 16px;
        border-top-left-radius: 8px;
        border: 1px solid var(--secondary-light-2);
        border-right: 0;
        border-bottom: 0;
    }

    &:last-of-type {
        padding-right: 16px;
        border-top-right-radius: 8px;
        border: 1px solid var(--secondary-light-2);
        border-left: 0;
        border-bottom: 0;
    }

    &.is-chrome { /* this allows the columns to be resized to 0, but only works on chrome */
        max-width: 0px;
    }

    &.sortable {
        cursor: pointer;
    }

    .sort-by {
        width: 9px;
        height: 7px;
        margin-left: 5px;

        flex-shrink: 0;

        top: 10px;
        position: relative;

        &:before {
            content: "";
            border-top: 5px solid var(--secondary-light-1);
            border-right: 4px solid transparent;
            border-left: 4px solid transparent;
        }
    }

    &.sorted {
        color: var(--secondary-dark-2);

        .sort-by:before {
            border-top: 5px solid var(--secondary-dark-2);
        }
    }

    &.sorted.descending .sort-by {
        top: -10px;

        &:before {
            border-bottom: 5px solid var(--secondary-dark-2);
            border-top: unset;
        }
    }
}
</style>
